module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w98"
  }, [_c('div', {
    staticClass: "crumb"
  }, [_c('span', [_c('router-link', {
    attrs: {
      "to": "/Help"
    }
  }, [_vm._v("帮助")]), _vm._v("  > ")], 1), _vm._v(" "), _c('span', [_vm._v("名师讲堂")])]), _vm._v(" "), _c('help-Menu'), _vm._v(" "), _c('div', {
    staticClass: "rightContent"
  }, [_c('div', {
    staticClass: "conten"
  }, [_c('P', {
    staticClass: "text"
  }, [_vm._v("点击tab【名师讲堂】，可默认查询当前所有上传过课程，课程数不为0的用户。（以下课程都特指对当前登陆用户有开放权限且已上架的课程，没有权限没上架的不显示在教学中心）。")]), _vm._v(" "), _c('el-collapse', {
    attrs: {
      "accordion": ""
    }
  }, [_c('el-collapse-item', [_c('template', {
    slot: "title"
  }, [_vm._v("\n                 课程查询\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("查询： 可在搜索框内输入课程名和专家名（支持模糊查询），也可选择已设置好的查询条件（医生职称、所属医院）对名师进行查询。")]), _vm._v(" "), _c('P', {
    staticClass: "text"
  }, [_vm._v("排序：名师默认按照“点赞最多”来进行排序。点击下拉排序方式，除“点赞最多”之外，还有“观看最多”“课程最多”。若有相应的名师，则会在查询结果区显示，若无，则会提示 “未查询到符合条件记录”。")]), _vm._v(" "), _c('P', {
    staticClass: "text"
  }, [_vm._v("点击名师头像和更多按钮，进入名师详情页，直接点击某课程则进入课程详情页。如图所示：")]), _vm._v(" "), _c('div', [_c('img', {
    attrs: {
      "src": require("../../../../static/image/60.png")
    }
  })])], 2), _vm._v(" "), _c('el-collapse-item', {
    attrs: {
      "title": "名师详情"
    }
  }, [_c('P', {
    staticClass: "text"
  }, [_vm._v("名师详情页显示名师基本信息、课程数、学习人数，以及名师所上传对当前用户有权限的课程，点击课程进入“课程详情页”可开始学习。")]), _vm._v(" "), _c('div', [_c('img', {
    attrs: {
      "src": require("../../../../static/image/61.png")
    }
  })])], 1)], 1)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-5e066653","hasScoped":true}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/moudle/ExcellentCourse/ThematicRead.vue
// module id = 570
// module chunks = 1 2 3 4 5 6 7 8